var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'crud-overlay-body': _vm.global, 'crud-overlay' : !_vm.global},attrs:{"c-wait":""}},[_c('span',{staticClass:"crud-wait-msg"},[_vm._v(" "+_vm._s(_vm._f("translate")(_vm.msg))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }